<script setup>
import { toRefs } from "vue";
import moment from "moment";
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";

const props = defineProps({
  employability: {
    type: Object,
  },
});

const { employability } = toRefs(props);

const formatDate = (date) => {
  return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
};
</script>

<template>
  <div v-if="Object.keys(employability).length > 0" class="pa-5">
    <h1>{{ employability.name }}</h1>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2">
            <v-icon>mdi-briefcase</v-icon> Employability Data
          </h3>
          <InfoHolder title="Employability Title" :info="employability.name" />
          <InfoHolder title="Date" :info="formatDate(employability.date)" />
          <InfoHolder
            title="Beneficiary Name"
            :info="employability.beneficiary?.name"
          />
          <InfoHolder title="Branch" :info="employability.branch?.name" />
          <InfoHolder
            title="Responsible Officer"
            :info="employability.responsibleOfficer?.name"
          />
        </div>
        <div class="d-flex" style="gap: 10px">
          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2">
              <v-icon>mdi-account-school-outline</v-icon> Enrolled Courses
            </h3>

            <div
              v-for="course in employability.courses"
              :key="course.id"
              class="pa-2"
            >
              <v-chip>
                {{ course.cycle }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-employability));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-employability));
      h3 {
        background-color: rgb(var(--v-theme-employability));
        color: black;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
